<template>
  <div id="checker-main" class="noselect">
    <span class="mark-main" v-show="showFailure" :class="markClass">{{mark}}</span>
  </div>
</template>

<script>
import { defineComponent, computed, toRef } from 'vue'

export default defineComponent({
  props: {
    checked: {
      default: false
    },
    failureMark: {
      default: true
    }
  },
  setup (props) {
    const checked = toRef(props, 'checked')
    const failureMark = toRef(props, 'failureMark')

    const markClass = computed(() => {
      if (checked.value) {
        return { success: true }
      } else {
        return { failure: true }
      }
    })

    const mark = computed(() => {
      if (checked.value) {
        return '✔'
      } else {
        return '✖'
      }
    })

    const showFailure = computed(() => {
      if (!checked.value && failureMark.value) {
        return false
      } else {
        return true
      }
    })

    return {
      mark,
      markClass,
      showFailure
    }
  }
})
</script>

<style lang="scss" scoped>
#checker-main {
  position: relative;
  .success {
    color: #00B050;
    font-weight: bold;
  }
  .failure {
    color: red;
    font-weight: bold;
  }
}
  .noselect {
  -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome and Opera */
  }
</style>
